import { useEffect, useRef, useState } from 'react';
import SiteLoader from '../components/SiteLoader/SiteLoader';
import BannerCarousel from '../components/Banner/BannerCarousel';
import EventTicker from '../components/EventTicker/EventTicker';
import ImageGrid from '../components/ImageGrid/ImageGrid';
import EventImageView from '../components/EventImageView/EventImageView';
import SiteFooter from '../components/SiteFooter/SiteFooter';
import { ScrollContext } from '../context/ScrollContext';
import { useSiteContent } from '../context/SiteContentContext';
import '../App.css';

function PublicSite() {
  const scrollRootRef = useRef(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const { bannerSlides, tickerEvents, gridImages, isLoading } = useSiteContent();

  useEffect(() => {
    document.title = 'inmotion';
  }, []);

  const handleEventSelect = (event) => {
    setSelectedEvent(event);
    requestAnimationFrame(() => {
      scrollRootRef.current?.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  };

  if (isLoading) {
    return <SiteLoader />;
  }

  return (
    <ScrollContext.Provider value={scrollRootRef}>
      <div className="app">
        <header className="app__header">
          {bannerSlides.length > 0 && <BannerCarousel banners={bannerSlides} />}
          {tickerEvents.length > 0 && (
            <EventTicker
              events={tickerEvents}
              selectedEventId={selectedEvent?.id}
              onEventSelect={handleEventSelect}
            />
          )}
        </header>
        <main ref={scrollRootRef} className="app__main">
          <div
            key={selectedEvent?.id ?? 'default-gallery'}
            className="app__content"
          >
            {selectedEvent ? (
              <EventImageView event={selectedEvent} />
            ) : gridImages.length > 0 ? (
              <ImageGrid images={gridImages} ariaLabel="All activity photos" />
            ) : (
              <section className="site-empty" aria-label="Site content">
                <p>No content published yet.</p>
              </section>
            )}
          </div>
        </main>
        <SiteFooter />
      </div>
    </ScrollContext.Provider>
  );
}

export default PublicSite;
